/* CALCULATEUR CALORIES */

function calculCalories(){

let poids = parseFloat(document.getElementById("cal-poids").value);
let taille = parseFloat(document.getElementById("cal-taille").value);
let age = parseFloat(document.getElementById("cal-age").value);
let activite = parseFloat(document.getElementById("cal-activite").value);
let sexe = document.getElementById("cal-sexe").value;

if(!poids || !taille || !age){
document.getElementById("cal-resultat").innerHTML = "Veuillez remplir tous les champs.";
document.getElementById("cal-objectifs").innerHTML = "";
return;
}

let bmr;

if(sexe === "homme"){
bmr = 10 * poids + 6.25 * taille - 5 * age + 5;
}else{
bmr = 10 * poids + 6.25 * taille - 5 * age - 161;
}

let calories = Math.round(bmr * activite);

let perte = calories - 400;
let prise = calories + 300;

document.getElementById("cal-resultat").innerHTML =
"Vos besoins énergétiques sont d'environ <strong>" + calories + " calories par jour</strong>";

document.getElementById("cal-objectifs").innerHTML =
"<br><strong>Objectifs estimés :</strong><br>"+
"Perte de poids : <strong>"+ perte +" calories/jour</strong><br>"+
"Maintien : <strong>"+ calories +" calories/jour</strong><br>"+
"Prise de masse : <strong>"+ prise +" calories/jour</strong>";

}



/* CALCULATEUR IMC */

function calculIMC(){

let poids = parseFloat(document.getElementById("imc-poids").value);
let taille = parseFloat(document.getElementById("imc-taille").value) / 100;

if(!poids || !taille){
document.getElementById("imc-result").innerHTML = "Veuillez remplir tous les champs.";
document.getElementById("imc-interpretation").innerHTML = "";
return;
}

let imc = poids / (taille * taille);
imc = imc.toFixed(1);

let interpretation = "";

if(imc < 18.5){
interpretation = "Insuffisance pondérale";
}
else if(imc < 25){
interpretation = "Poids normal";
}
else if(imc < 30){
interpretation = "Surpoids";
}
else if(imc < 35){
interpretation = "Obésité modérée";
}
else if(imc < 40){
interpretation = "Obésité sévère";
}
else{
interpretation = "Obésité morbide";
}

document.getElementById("imc-result-box").style.display = "block";

document.getElementById("imc-result").innerHTML =
"Votre IMC est : <strong>" + imc + "</strong>";

document.getElementById("imc-interpretation").innerHTML =
"Interprétation : " + interpretation;

}